import { ActionTag } from '../../../shared/ui';

type FiltersProps<T extends Record<string, { label: string }>> = {
  items: T;
  filter: keyof T;
  onFilterChange: (filter: keyof T) => void;
};

export const SearchModalTagFilters = <
  T extends Record<string, { label: string }>
>({
  items,
  filter,
  onFilterChange,
}: FiltersProps<T>) => {
  return (
    <div className="flex flex-nowrap gap-x-1 sticky top-0 left-0 right-0 h-9 bg-base-white">
      {Object.keys(items).map((key) => (
        <ActionTag
          key={key}
          variant={filter === key ? 'primary-active' : 'primary'}
          size="md"
          onClick={() => onFilterChange(key as keyof T)}
        >
          {items[key as keyof T].label}
        </ActionTag>
      ))}
    </div>
  );
};
